import { imageUtils } from "@/business/shared/commons/imageUtils/imageUtils";

export interface Reference {
  reference: string;
  description: string;
  main: string;
  additional: AdditionalImage[];
}

export interface AdditionalImage {
  slider: string;
  full: string;
}

export interface AddMainImageRequest {
  reference: string;
  description: string;
  image: File;
  isEdit: string;
}

export interface AddSliderImagesRequest {
  position: number;
  isSliderEdited: string;
  isBigImageEdited: string;
  reference: string;
  slider: File | null;
  bigImage: File | null;
}

export interface DeleteInventoryImageRequest {
  reference: string;
  position: number;
}

export function InventoryActions() {
  function createReference(
    reference: string,
    description: string,
    main: string,
    additional: AdditionalImage[]
  ): Reference {
    return {
      reference: reference,
      description: description,
      main: main,
      additional: additional,
    };
  }

  function infoAdditionalImage(slider: string, full: string): AdditionalImage {
    return {
      slider: slider,
      full: full,
    };
  }

  function addMainImageRequest(
    reference: string,
    description: string,
    image: File,
    isEdit: string
  ): AddMainImageRequest {
    return {
      reference: reference,
      description: description,
      image: image,
      isEdit: isEdit,
    };
  }

  function addSliderImagesRequest(
    position: number,
    isSliderEdited: string,
    isBigImageEdited: string,
    reference: string,
    slider: File | null,
    bigImage: File | null
  ): AddSliderImagesRequest {
    return {
      position: position,
      isSliderEdited: isSliderEdited,
      isBigImageEdited: isBigImageEdited,
      reference: reference,
      slider: slider,
      bigImage: bigImage
    };
  }

  function inventoryDeleteImageRequest(
    reference: string,
    position: number
  ): DeleteInventoryImageRequest {
    return {
      reference: reference,
      position: position,
    };
  }

  function deserialize(object: string): Reference[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    const keys: string[] = Object.keys(parseResponse);
    const values: Reference[] = Object.values(parseResponse);
    values.forEach((value, index) => {
      value.reference = keys[index];
      value.main = imageUtils.putTimeStamp(value.main);
      if (value.additional) {
        value.additional.forEach((additionalImage: AdditionalImage) => {
          additionalImage.full = imageUtils.putTimeStamp(additionalImage.full);
          additionalImage.slider = imageUtils.putTimeStamp(
            additionalImage.slider
          );
        });
      }
    });
    return values;
  }

  function deserializeAdditionalImage(object: string): AdditionalImage[] {
    const parseResponse = JSON.parse(JSON.stringify(object));
    return parseResponse.map((image: AdditionalImage) => {
      return infoAdditionalImage(image.slider, image.full);
    });
  }

  return {
    createReference,
    infoAdditionalImage,
    addMainImageRequest,
    addSliderImagesRequest,
    inventoryDeleteImageRequest,
    deserialize,
    deserializeAdditionalImage,
  };
}
